<template>
  <div class="flex items-center justify-between">
    <div class="flex-1 flex justify-between sm:hidden">
      <Link
        :data="data"
        preserve-scroll
        preserve-state
        :href="pagination.links.prev"
        v-if="pagination.meta.current_page > 1"
        class="
          relative
          inline-flex
          items-center
          px-4
          py-2
          border border-gray-300
          text-sm
          leading-5
          font-medium
          rounded-md
          text-gray-700
          bg-white
          hover:text-gray-500
          focus:outline-none
          focus:shadow-outline-light-blue
          focus:border-light-blue-300
          active:bg-gray-100 active:text-gray-700
          transition
          ease-in-out
          duration-150
        "
        >{{ t("Previous") }}</Link
      >
      <div
        v-else
        class="
          relative
          inline-flex
          items-center
          px-4
          py-2
          border border-gray-300
          text-sm
          leading-5
          font-medium
          rounded-md
          text-gray-400
          focus:outline-none
          focus:shadow-outline-light-blue
          focus:border-light-blue-300
          bg-gray-200
          active:bg-gray-200 active:text-gray-400
          transition
          ease-in-out
          duration-150
        "
      >
        {{ t("Previous") }}
      </div>
      <Link
        :data="data"
        preserve-scroll
        preserve-state
        :href="pagination.links.next"
        v-if="pagination.meta.current_page < pagination.meta.last_page"
        class="
          relative
          inline-flex
          items-center
          px-4
          py-2
          border border-gray-300
          text-sm
          leading-5
          font-medium
          rounded-md
          text-gray-700
          bg-white
          hover:text-gray-500
          focus:outline-none
          focus:shadow-outline-light-blue
          focus:border-light-blue-300
          active:bg-gray-100 active:text-gray-700
          transition
          ease-in-out
          duration-150
        "
        >{{ t("Next") }}</Link
      >
      <div
        v-else
        class="
          relative
          inline-flex
          items-center
          px-4
          py-2
          border border-gray-300
          text-sm
          leading-5
          font-medium
          rounded-md
          text-gray-400
          focus:outline-none
          focus:shadow-outline-light-blue
          focus:border-light-blue-300
          bg-gray-200
          active:bg-gray-200 active:text-gray-400
          transition
          ease-in-out
          duration-150
        "
      >
        {{ t("Next") }}
      </div>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-end">
      <div>
        <nav class="relative z-0 inline-flex shadow-sm">
          <Link
            :data="data"
            preserve-scroll
            preserve-state
            :href="pagination.links.prev"
            v-if="pagination.meta.current_page > 1"
            class="
              relative
              inline-flex
              items-center
              px-2
              py-2
              rounded-l-md
              border border-gray-300
              bg-white
              text-sm
              leading-5
              font-medium
              text-gray-500
              hover:text-gray-400
              focus:z-10
              focus:outline-none
              focus:border-light-blue-300
              focus:shadow-outline-light-blue
              active:bg-gray-100 active:text-gray-500
              transition
              ease-in-out
              duration-150
            "
            :aria-label="t('Previous')"
          >
            <ChevronLeftIcon class="h-5 w-5" />
          </Link>
          <div
            v-else
            class="
              relative
              inline-flex
              items-center
              px-2
              py-2
              rounded-l-md
              border border-gray-300
              text-sm
              leading-5
              font-medium
              text-gray-400
              hover:text-gray-400
              focus:z-10
              focus:outline-none
              focus:border-light-blue-300
              focus:shadow-outline-light-blue
              bg-gray-200
              active:bg-gray-100 active:text-gray-400
              transition
              ease-in-out
              duration-150
            "
          >
            <ChevronLeftIcon class="h-5 w-5" />
          </div>

          <Link
            :data="data"
            preserve-scroll
            preserve-state
            :href="pagination.links.next"
            v-if="pagination.meta.current_page < pagination.meta.last_page"
            class="
              -ml-px
              relative
              inline-flex
              items-center
              px-2
              py-2
              rounded-r-md
              border border-gray-300
              bg-white
              text-sm
              leading-5
              font-medium
              text-gray-500
              hover:text-gray-400
              focus:z-10
              focus:outline-none
              focus:border-light-blue-300
              focus:shadow-outline-light-blue
              active:bg-gray-100 active:text-gray-500
              transition
              ease-in-out
              duration-150
            "
            :aria-label="t('Next')"
          >
            <ChevronRightIcon class="h-5 w-5" />
          </Link>
          <div
            v-else
            class="
              -ml-px
              relative
              inline-flex
              items-center
              px-2
              py-2
              rounded-r-md
              border border-gray-300
              text-sm
              leading-5
              font-medium
              text-gray-400
              hover:text-gray-400
              focus:z-10
              focus:outline-none
              focus:border-light-blue-300
              focus:shadow-outline-light-blue
              bg-gray-200
              active:bg-gray-100 active:text-gray-400
              transition
              ease-in-out
              duration-150
            "
          >
            <ChevronRightIcon class="h-5 w-5" />
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/solid";

export default {
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
    },
  },

  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n>
{
  "es": {
    "Previous": "Anterior",
    "Next": "Siguiente"
  }
}
</i18n>
